import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { HelpersService } from '../../../../../../../../services/helpers.service';
import { RentalsService } from '../../../../../../../../services/rentals.service';


@Component({
  selector: 'app-initiate-rental-payment-refund',
  templateUrl: './initiate-rental-payment-refund.component.html',
  styleUrls: ['./initiate-rental-payment-refund.component.scss']
})
export class InitiateRentalPaymentRefundComponent {

  @Input() payments;
  @Input() partner;
  @Input() countryData;
  @Output() refundComplete = new EventEmitter()


  public refundOptions : any = [];
  public selectedTransaction : any = null;
  public refundAmount : number;
  public busyRefunding : boolean = false;
  public errorMessage : string = null;


  constructor(
    private helpersService: HelpersService,
    private rentalsService : RentalsService
    ) {}
  
    ngOnInit() {
      this.setRefundOptions();
    }

    setRefundOptions(){
      this.refundOptions = this.payments.filter((x:any)=>{return x.paymentMethod === "STRIPE"}).map(x=>{return {
        paymentTransactionID : x.id, 
        stripePaymentIntent: x.stripePaymentIntent,
        amountPaid : x.amountPaid,
        partnerID : x.partnerID,
        label: x.stripePaymentIntent + " (" +this.partner.CurrencySymbol + x.amountPaid + ")",
        refunds : x.refunds,
        refundedAmount : x.refunds ? x.refunds.map((x:any)=>{return x.amountRefunded}).reduce((acc, num) => acc + num, 0) : 0
        }
      }).filter(x=>{return x.amountPaid != x.refundedAmount});
    }

    isValid(){
      if(this.selectedTransaction && this.refundAmount && this.refundAmount > 1 && this.refundAmount <= this.maxRefundAmount()){
        return true;
      }else{
        return false;
      }
    }

    maxRefundAmount(){
      if(this.selectedTransaction){
        var paymentsTotal = this.selectedTransaction.amountPaid;
        var refundsTotal = 0;
        if(this.selectedTransaction.refunds && this.selectedTransaction.refunds.length > 0){      
          refundsTotal += this.selectedTransaction.refunds.map((x:any)=>{return x.amountRefunded}).reduce((acc, num) => acc + num, 0);  
        }
        return paymentsTotal - refundsTotal;
      }else{
        return 0;
      }
    }

    refundPayment(){
      this.errorMessage = null;
      var data = {
        "PartnerID": this.selectedTransaction.partnerID,
        "PaymentTransactionID": this.selectedTransaction.paymentTransactionID,
        "RefundAmount": this.refundAmount
      };
      this.busyRefunding = true;
      this.rentalsService.refundStripePayment(data).subscribe(res=>{
        this.refundComplete.emit();
        this.busyRefunding = false;
      },err=>{
        if(err && err.error && err.error.error){
          this.errorMessage = err.error.error;
        }
        this.busyRefunding = false;
      })
    }

}
